module.exports = __webpack_public_path__ + "assets/img/19.94f52d75.png";